import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=081ae709"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"
import style0 from "./layout.vue?vue&type=style&index=0&id=081ae709&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/graphileon/graphileon/release/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('081ae709')) {
      api.createRecord('081ae709', component.options)
    } else {
      api.reload('081ae709', component.options)
    }
    module.hot.accept("./layout.vue?vue&type=template&id=081ae709", function () {
      api.rerender('081ae709', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/renderers/layout-view-renderer/layout.vue"
export default component.exports